<template>
  <div class="d-flex align-center row-gap-4 justify-space-between flex-wrap">
    <div class="d-flex align-center column-gap-4">
      <SearchTextField
        v-model="search"
        :disabled="isPristineChecklist"
        :tooltipText="searchTooltipText"
        @clear="updateSearchQuery('')"
      />

      <app-button
        data-locator="filters-button"
        :disabled="isPristineChecklist"
        @click="onOpenFiltersPane"
      >
        <template #left-icon>
          <app-icon-ds
            icon="sliders"
            size="xs"
          />
        </template>
        {{ $t('common.filters') }}
      </app-button>
    </div>
    <div class="d-flex">
      <app-dropdown-button
        button-classes="mr-4"
        data-locator="options-menu-button"
        :disabled="isPristineChecklist"
        type="outlined"
        variant="neutral"
      >
        {{ $t('project.checklist.ChecklistHeader.options') }}
        <template #list>
          <v-list data-locator="checklist-options-menu">
            <app-dropdown-button-item 
              data-locator="show-all-attachments-menu-item"
              icon="paperclip"
              :label="$t('project.checklist.ChecklistHeader.showAttachments')"
              @click="onShowAttachmentsClick"
            />

            <v-divider />

            <template v-if="isCurrentUserPm && isSubscriber">
              <app-dropdown-button-item 
                data-locator="save-checklist-menu-item"
                icon="save"
                :label="$t('project.checklist.ChecklistHeader.saveChecklist')"
                @click="onSaveChecklistClick"
              />
              
              <v-divider />
            </template>
            
            <AppDownloadFile
              :link="`${baseURL}/room/${roomMnemo}/downloads/todo-pdf`"
              class="d-block"
              forceReader
            >
              <template #default="{submitForm}">
                <app-dropdown-button-item 
                  data-locator="pdf-export-menu-item"
                  icon="file-pdf"
                  :label="$t('project.checklist.ChecklistHeader.exportToPDF')"
                  @click="submitForm"
                />
              </template>
            </AppDownloadFile>

            <AppDownloadFile :link="`${baseURL}/room/${roomMnemo}/downloads/todo-word`" class="d-block">
              <template #default="{submitForm}">
                <app-dropdown-button-item 
                  data-locator="word-export-menu-item"
                  icon="file-word"
                  :label="$t('project.checklist.ChecklistHeader.exportToWord')"
                  @click="submitForm"
                />
              </template>
            </AppDownloadFile>
            
            <app-dropdown-button-item 
              data-locator="share-by-mail-menu-item"
              icon="share"
              :label="$t('project.checklist.ChecklistHeader.shareByEmail')"
              @click="onSendChecklistByEmailClick"
            />
          </v-list>
        </template>
      </app-dropdown-button>

      <ChecklistAddButton v-if="isCurrentUserPm" data-locator="add-menu-button" />
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash-es'
import { mapActions, mapGetters, mapMutations } from 'vuex'

import AppDownloadFile from '@/common/AppDownloadFile.vue'
import SearchTextField from '@/common/SearchTextField.vue'
import {
  DELETE_SEARCH_RESULTS,
  GET_SEARCH_RESULTS,
  OPEN_CHECKLIST_SHARE_BY_EMAIL_PANE,
  OPEN_SAVE_CHECKLIST_DIALOG,
} from '@/store/modules/checklist/action_types'
import { SET_FILTERS_PANE_IS_OPEN, SET_GLOBAL_ATTACHED_FILES_DIALOG_IS_OPEN } from '@/store/modules/checklist/mutation_types'

import ChecklistAddButton from './ChecklistAddButton.vue'

export default {
  name: 'ChecklistHeader',
  components: {
    AppDownloadFile,
    ChecklistAddButton,
    SearchTextField,
  },
  data () {
    return {
      searchQuery: '',
    }
  },
  computed: {
    ...mapGetters('checklist', ['isPristineChecklist']),
    ...mapGetters('room', ['isCurrentUserPm', 'roomMnemo']),
    ...mapGetters('user', ['isSubscriber']),
    baseURL () {
      return import.meta.env.VUE_APP_API_URL
    },
    search: {
      get () {
        return this.searchQuery
      },
      set: debounce(function (val) {
        this.updateSearchQuery(val)
      }, 1000),
    },
    searchTooltipText () {
      return this.isPristineChecklist ? null : this.$t('project.checklist.ChecklistHeader.searchPlaceholder')
    },
  },
  methods: {
    ...mapActions('checklist', [
      DELETE_SEARCH_RESULTS,
      GET_SEARCH_RESULTS,
      OPEN_SAVE_CHECKLIST_DIALOG,
      OPEN_CHECKLIST_SHARE_BY_EMAIL_PANE,
    ]),
    ...mapMutations('checklist', [SET_FILTERS_PANE_IS_OPEN, SET_GLOBAL_ATTACHED_FILES_DIALOG_IS_OPEN]),
    onSaveChecklistClick () {
      this.OPEN_SAVE_CHECKLIST_DIALOG()
    },
    onShowAttachmentsClick () {
      this.SET_GLOBAL_ATTACHED_FILES_DIALOG_IS_OPEN(true)
    },
    onSendChecklistByEmailClick () {
      this.OPEN_CHECKLIST_SHARE_BY_EMAIL_PANE()
    },
    onOpenFiltersPane () {
      this.SET_FILTERS_PANE_IS_OPEN(true)
    },
    searchChecklist () {
      this.search ? this.GET_SEARCH_RESULTS(this.searchQuery) : this.DELETE_SEARCH_RESULTS()
    },
    updateSearchQuery (searchQuery) {
      this.searchQuery = searchQuery
      this.searchChecklist()
    },
  },
}
</script>
